import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";

import { format, parseISO } from "date-fns";
import { ApiAdimplencia } from "../../../../services/api";
import { DataTablePague } from "../../../../styles/primeReactConfig";
import useTerminologiaRecorrencia from "../../../../hooks/useTerminologiaRecorrencia";

function ImportacaoErrorDialog({ close, reportInfo }) {
  const terminologia = useTerminologiaRecorrencia();
  const [errorData, setErrorData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(0);
  const [first, setFirst] = useState(0);

  useEffect(() => {
    async function getReport() {
      setLoading(true);
      try {
        const { data } = await ApiAdimplencia.get(`/cargas/${reportInfo.carga_id}/lotes?limit=${rows}&page=${page}`);
        setErrorData(data.dados.lotes);
        setTotalRecords(data.dados.count);
      } catch (error) {
        console.log(error);
        toast.error('Erro de conexão com o sistema, tente novamente mais tarde!');
      } finally {
        setLoading(false);
      }
    }

    getReport();
  }, [page, reportInfo.carga_id, rows]);

  function onPage(event) {
    const startIndex = parseInt(event.first);
    setRows(event.rows);
    setPage(event.page);
    setFirst(startIndex);
  }

  const statusBodyTemplate = (e) => {
    const typeMap = {
      'DOCUMENTO DUPLICADO': 'bg-red-100 text-red-800 dark:bg-red-800/30 dark:text-red-500 ring-red-500 ring-1 ring-inset',
      'aguardando': 'text-blue-800 dark:bg-blue-800/30 dark:text-blue-500 ring-blue-500 ring-1 ring-inset',
      'LINHA CARREGADA': 'bg-teal-100 text-teal-800 dark:bg-teal-800/30 dark:text-teal-500 ring-teal-500 ring-1 ring-inset',
      'parcial': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800/30 dark:text-yellow-500 ring-yellow-500 ring-1 ring-inset',
    };

    const type = typeMap[e.status] || 'bg-gray-100 text-gray-800 dark:bg-white/10 dark:text-white';

    return (
      <div className={`inline-flex items-center justify-center rounded-sm ${type} px-2 py-1 text-sm font-medium w-fit`}>
        <p>{e.status}</p>
      </div>)
  };

  const formatCurrency = (value) => {
    return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const headerTabelaError = (
    <div className="justify-between mt-2 px-4 text-pink-400 text-sm">
      *A prévia exibe apenas as primeiras linhas da página<br />
      *Faça o download do arquivo para ver o relatório completo
    </div>
  )

  return (
    <Dialog
      className='!w-fit'
      header="Relatório de Processamento"
      onHide={() => close()}
      visible
    >
      <div className="md:w-[70vw] w-[90vw] md:h-fit h-[70vh] overflow-auto">
        <DataTable
          header={headerTabelaError}
          pt={DataTablePague}
          value={errorData}
          loading={loading}
          totalRecords={totalRecords}
          first={first}
          rows={rows}
          onPage={onPage}
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
          emptyMessage="Nenhuma relatório gerado."
          size="small"
          scrollHeight="480px"
          scrollable
          paginator
          lazy
        >
          <Column
            field="carga_status"
            header="Situação"
            body={rowData => statusBodyTemplate({ status: rowData.situacao.nome, label: rowData.situacao.label })}
          />
          <Column field="numero_contrato" header="Número Cliente" />
          <Column field="nome_devedor" style={{ width: '30rem' }} header="Nome Devedor" />
          <Column field="documento_devedor" header="Documento" />
          <Column field="email_devedor" header="E-mail" />
          <Column field="telefone_devedor" header="Telefone" />
          <Column
            field="data_nascimento"
            header="Nascimento"
            body={(rowData) => (rowData.data_nascimento) ? format(parseISO(rowData.data_nascimento), "dd/MM/yyyy") : ''}
          />
          <Column field="grupo_devedor" header={terminologia.labelGrupo} />
          <Column field="recebivel" header="Descrição Débito" />
          <Column
            field="primeiro_vencimento"
            header="Primeiro Vencimento"
            body={(rowData) => (rowData.primeiro_vencimento) ? format(parseISO(rowData.primeiro_vencimento), "dd/MM/yyyy") : ''}
          />
          <Column
            field="ultimo_vencimento"
            header="Último Vencimento"
            body={(rowData) => (rowData.ultimo_vencimento) ? format(parseISO(rowData.ultimo_vencimento), "dd/MM/yyyy") : ''}
          />
          <Column field="valor" header="Valor" body={rowData => (rowData.valor) ? formatCurrency(rowData.valor) : ''} />
          <Column field="desconto" header="Desconto" />
          <Column field="dia_vencimento" header="Dia Vencimento" />
          <Column field="beneficiario" header="Beneficiário" />
          <Column field="periodicidade" header="Periodicidade" />
          <Column field="endereco_devedor" header="Endereço" />
          <Column field="numero_devedor" header="Número" />
          <Column field="complemento_devedor" header="Complemento" />
          <Column field="bairro_devedor" header="Bairro" />
          <Column field="cidade_devedor" header="Cidade" />
          <Column field="uf_devedor" header="UF" />
          <Column field="cep_devedor" header="CEP" />
        </DataTable>
      </div>
    </Dialog>
  )
}

export default ImportacaoErrorDialog
